<template>
  <div class="jumbotron jumbotron-fluid mb-0" style="height: 100vh;">
    <div class="container">
      <h1 class="display-3">RAINN Speakers Bureau</h1>
      <p class="lead">Thank you for coming forward to speak.</p>
      <p class="lead">
        We have created a Speaker account for you. With your account you can
        securely update any information and view your submitted applications at
        any time. To get started, you can go
        <a href="/login">here</a> to reset your password and login your new
        account.
      </p>
      <hr class="my-4" />
      <p class="lead">
        <a class="btn btn-primary btn-sm" href="https://rainn.org" role="button"
          >Return to RAINN.org</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "thanks"
};
</script>

<style></style>
